import { Component, Input } from "@angular/core";

import { NzSkeletonComponent } from "ng-zorro-antd/skeleton";
import { UiSkeletonAvatar, UiSkeletonParagraph, UiSkeletonTitle } from "@webapp/ui/skeleton/skeleton.type";

@Component({
  selector: "ui-skeleton",
  exportAs: "uiSkeleton",
  templateUrl: "skeleton.component.html",
})
export class UiSkeletonComponent extends NzSkeletonComponent {
  @Input("uiActive") public nzActive = false;
  @Input("uiLoading") public nzLoading = true;
  @Input("uiRound") public nzRound = false;
  @Input("uiTitle") public nzTitle: UiSkeletonTitle | boolean = true;
  @Input("uiAvatar") public nzAvatar: UiSkeletonAvatar | boolean = false;
  @Input("uiParagraph") public nzParagraph: UiSkeletonParagraph | boolean = true;
}
